// extracted by mini-css-extract-plugin
export var label = "_bx-5";
export var slideContainer = "_bx-0";
export var slider = "_bx-1";
export var sliderLg = "_bx-4";
export var sliderMd = "_bx-3";
export var sliderSm = "_bx-2";